
                export default function (Component) {
                    Component.__source = "library/components/VabTheme/components/VabThemeDrawer.vue"
                }
            